<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-10 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
        >
            <div class="shadow-md rounded w-full sm:w-11/12 max-w-5xl overflow-y-auto p-4 md:p-9 bg-white text-ink">
                <div class="mb-4 flex justify-end">
                    <button
                        @click="emitClose"
                        type="button"
                        aria-label="close modal"
                    >
                        <img
                            src="../assets/images/icons/close.svg"
                            width="20"
                            height="20"
                            alt="X"
                        >
                    </button>
                </div>

                <div class="mb-4 flex flex-col md:flex-row justify-between gap-7 sm:gap-12">
                    <div class="md:w-1/2 max-h-[33%] overflow-hidden aspect-video flex flex-col justify-center">
                        <img
                            :src="modalImage"
                            alt=""
                        >
                    </div>

                    <div class="mb-6 md:mb-10 md:w-1/2 text-center md:text-left">
                        <h1 class="mb-3 md:mb-4 text-2xl font-bold tracking-wide">
                            {{ $t('SHARE_DESIGN') }}
                        </h1>

                        <h2 class="mb-6 md:mb-10 text-sm font-gotham font-medium normal-case">
                            {{ productName }}
                        </h2>

                        <ul>
                            <li class="border-b border-gray p-5">
                                <share-modal-button
                                    @click="copyLink"
                                    :icon-name="linkCopied ? 'check-green' : 'link'"
                                >
                                    <span v-if="!linkCopied">
                                        {{ $t('COPY') }}
                                    </span>

                                    <span v-else>
                                        {{ $t('COPIED') }}
                                    </span>
                                </share-modal-button>
                            </li>

                            <li class="border-b border-gray p-5">
                                <share-modal-button
                                    @click="openEmailModal"
                                    icon-name="email"
                                >
                                    {{ $t('EMAIL_DESIGN') }}
                                </share-modal-button>
                            </li>

                            <li class="border-b border-gray p-5">
                                <share-modal-button
                                    @click="printDesign"
                                    icon-name="print"
                                >
                                    {{ $t('PRINT') }}
                                </share-modal-button>
                            </li>

                            <li class="pt-5 px-5">
                                <share-modal-button
                                    @click="addToWishlist"
                                    icon-name="heart"
                                >
                                    {{ $t('ADD_TO_WISHLIST') }}
                                </share-modal-button>
                            </li>

                            <template v-if="showSpecial">
                                <li class="mt-8 pt-5 px-5">
                                    <share-modal-button
                                        @click="make360Video(5)"
                                        icon-name="link"
                                    >
                                        Make 5 second 360° video
                                    </share-modal-button>
                                </li>

                                <li class="pt-5 px-5">
                                    <share-modal-button
                                        @click="make360Video(10)"
                                        icon-name="link"
                                    >
                                        Make 10 second 360° video
                                    </share-modal-button>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>

            <share-modal-email
                @modalClose="showEmailModal = false"
                :show-modal="showEmailModal"
            />

            <share-modal-login
                v-if="addToWishlistMessage !== null"
                @modalClose="clearMessage"
                :show-modal="addToWishlistMessage !== null"
                :feedback="addToWishlistMessage"
            />
        </div>
    </transition>
</template>

<script>
    import allStores from '../stores/all';

    import ShareModalButton from './ShareModalButton.vue';
    import ShareModalEmail from './ShareModalEmail.vue';
    import ShareModalLogin from './ShareModalLogin.vue';

    export default {
        mixins: [allStores],

        components: {
            ShareModalButton,
            ShareModalEmail,
            ShareModalLogin,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            showSpecial: {
                type: Boolean,
                default: false,
            },
            modalImage: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                showEmailModal: false,
            };
        },

        computed: {
            productName() {
                return this.customizerStore.productName;
            },

            linkCopied() {
                return this.appStore.linkCopied;
            },

            addToWishlistMessage() {
                return this.customizerStore.addToWishlistMessage;
            },
        },

        methods: {
            copyLink() {
                this.customizerStore.saveAndCopyLink();
            },

            openEmailModal() {
                this.showEmailModal = true;
            },

            printDesign() {
                this.customizerStore.saveAndPrint();
            },

            addToWishlist() {
                this.customizerStore.addToWishlistAndExit();
            },

            clearMessage() {
                this.customizerStore.setAddToWishlistMessage(null);
            },

            emitClose() {
                this.appStore.setLinkCopied(false);

                this.$emit('modalClose');
            },

            make360Video(duration) {
                this.customizerStore.make360Video(duration);

                this.$emit('modalClose');
            },
        },
    };
</script>
